module.exports = __webpack_public_path__ + "static/map-bbe22fd02ca3054d08ee7665815b2f2a.jpg";